import { StackProps, VStack } from '@chakra-ui/react';
import React from 'react';

import { colors } from '~/packages/common-frontend/colors';

export const BoundingBox = ({ children, ...props }: StackProps) => {
  const {
    alignItems,
    borderColor,
    borderRadius,
    p,
    padding,
    spacing,
    w,
    width,
  } = props;
  return (
    <VStack
      {...props}
      w={w || width || '100%'}
      spacing={spacing || '24px'}
      alignItems={alignItems || 'flex-start'}
      p={p || padding || '40px'}
      border="1px solid"
      borderRadius={borderRadius || '8px'}
      borderColor={borderColor || colors.gray[200]}
    >
      {children}
    </VStack>
  );
};
